<script setup>
defineProps({
  width: {
    type: Number,
    default: 24,
  },
  height: {
    type: Number,
    default: 24,
  },
});
</script>

<template>
  <svg
    :width="width"
    :height="height"
    viewBox="0 0 24 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      fill-rule="evenodd"
      clip-rule="evenodd"
      d="M1.00707 6.2168C1.00236 6.2776 1 6.3384 1 6.4V17.6C1 18.2368 1.24828 18.8472 1.69064 19.2968C2.13221 19.7472 2.73171 20 3.35714 20H20.6429C21.2683 20 21.8678 19.7472 22.3094 19.2968C22.7517 18.8472 23 18.2368 23 17.6V6.4C23 6.348 22.9984 6.296 22.9953 6.2448L13.2108 12.9952C12.4643 13.4496 11.5341 13.448 10.7892 12.9928L1.00707 6.2168ZM1.65057 4.7448L11.5977 11.6208C11.846 11.7728 12.1564 11.7736 12.4047 11.6216L22.3667 4.76321C22.3479 4.74241 22.329 4.7224 22.3094 4.7032C21.8678 4.2528 21.2683 4 20.6429 4H3.35714C2.73171 4 2.13221 4.2528 1.69064 4.7032C1.67728 4.7168 1.66393 4.7304 1.65057 4.7448Z"
      fill="#8C8C8C"
    />
  </svg>
</template>
